// src/components/safety/view/SCARView.jsx
import React, { useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import TinyMCEpreview from "../../const/TinyMCEpreview";
import TinyMCEeditor from "../../const/TinyMCEeditor";
import TableCell from "../../common/ui/TableCell";
import { getSafetyDocDetail, saveSafetyDoc } from "../../../api/safety";
import { addApprovalLine, viewApprovalLine } from "../../../api/approval";
import ApprovalAction_CM from "../../approval/ApprovalAction_CM";
import SignTableDoc from "../../approval/SignTable_doc";
import PhotoBoardReadonly from "../../const/Photo/PhotoBoardReadonly";
import PhotoBoardSelect from "../../const/Photo/PhotoBoardSelect";

export default function SCARView({ doc, currentUser = {} }) {
  const { dns } = useParams();
  const meta = doc?.meta || {};
  const editorRef = useRef(null);

  const [actionText, setActionText] = useState("");
  const [actionPhotoBoard, setActionPhotoBoard] = useState(null);
  // 모달 공용
  const [openPhotoModal, setOpenPhotoModal] = useState(false);

  // 누가 열었는지 구분
  const [photoModalContext, setPhotoModalContext] = useState(null);
  // "action" | "approval"
  const [photoModalOrder, setPhotoModalOrder] = useState(null);




  /* =========================
     로그인 정보
  ========================= */
  const myId = Number(currentUser?.id || 0);
  const myName = currentUser?.name || "";

  /* =========================
     조치 / 결재 데이터
  ========================= */
  const actionHistories = Array.isArray(meta.action_histories)
    ? meta.action_histories
    : [];

  const approvalLines = Array.isArray(doc.approval_lines)
    ? doc.approval_lines
    : [];

  const showApprovalPanel =
    approvalLines.length === actionHistories.length + 1 &&
    doc.status === "in_progress";


  /** order 기준으로 조치 + 확인 묶기 */
  const mergedHistories = actionHistories.map((h) => {
    const approval = approvalLines.find(
      (a) => Number(a.order) === Number(h.order)
    );
    return { ...h, approval };
  });


  const nextOrder = actionHistories.length + 1;

  // console.log(meta.reference_users);

  /* =========================
     권한
  ========================= */
  const canWriteAction =
    (
      (
        Array.isArray(meta.reference_users) &&
        meta.reference_users.map(Number).includes(myId)
      ) ||
      (
        Array.isArray(doc.persons) &&
        doc.persons.map(p => Number(p.id)).includes(myId)
      )
    )
    && ["none", "rejected"].includes(doc.status);


  /* =========================
     새 조치 상태
  ========================= */
  const [isWriting, setIsWriting] = useState(false);
  const [actionStatus, setActionStatus] = useState("completed");
  const [saving, setSaving] = useState(false);

  /* =========================
     새 조치 추가 (append)
  ========================= */
  const handleAddAction = async () => {
    if (!actionText.trim()) {
      alert("조치 결과를 입력해주세요.");
      return;
    }


    try {
      setSaving(true);

      const latest = await getSafetyDocDetail(dns);
      const latestMeta = latest?.meta || {};
      const prev = Array.isArray(latestMeta.action_histories)
        ? latestMeta.action_histories
        : [];

      const me = JSON.parse(localStorage.getItem("user"));

      const newHistory = {
        order: prev.length + 1,
        action: {
          author_id: me.id,
          author_name: me.name,
          author_position: me.position || "",
          author_sign: me.sign || null,

          content: actionText,
          photoboard: actionPhotoBoard || null,

          status: actionStatus,
          date: new Date().toISOString().slice(0, 10),
        },
      };

      await saveSafetyDoc({
        dns,
        project: doc.project,
        title: doc.title,
        doc_type: doc.doc_type,
        status: "none",
        meta: {
          ...latestMeta,
          action_histories: [...prev, newHistory],
          progress:
            actionStatus === "completed" ? "completed" : "in_progress",
        },
      });

      alert("조치 결과가 추가되었습니다.");
      setActionText("");
      setActionPhotoBoard(null);

      window.location.reload();
    } catch (e) {
      console.error(e);
      alert("저장 실패");
    } finally {
      setSaving(false);
    }

  };

  /* =========================
     결재 요청 (마지막 조치 완료 시)
  ========================= */
  const lastAction = actionHistories[actionHistories.length - 1];
  const canSubmitApproval =
    canWriteAction && lastAction?.action?.status === "completed";

  const handleSubmitApproval = async () => {
    try {
      const approverId = doc.created_by?.id;
      if (!approverId) {
        alert("문서 작성자를 찾을 수 없습니다.");
        return;
      }

      await saveSafetyDoc({
        dns,
        project: doc.project,
        title: doc.title,
        doc_type: doc.doc_type,
        status: "submit",
        meta,
      });

      const res = await viewApprovalLine(dns);
      const lines = res.data?.approval_lines || [];
      console.log("$$$", lines.length)

      await addApprovalLine({
        doc_dns: dns,
        approver_id: approverId,
        order: lines.length + 1,
      });


      alert("결재 요청이 완료되었습니다.");
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert("결재 요청 실패");
    }
  };

  // SCARView.jsx


  const actor = {
    label: "조치자",
    name: lastAction?.action?.author_name || "-",
    position: lastAction?.action?.author_position || "",
    sign: lastAction?.action?.author_sign || null,
    state:
      lastAction?.action?.status === "completed"
        ? "approved"
        : "waiting",
  };




  /* =========================
     렌더링
  ========================= */
  return (
    <div className="w-full space-y-4 text-sm">
      {/* ================= 부적합 내용 ================= */}
      <section>
        <div className="tbl-label-bg">부적합 내용</div>

        <div className="border-r border-l border-b border-black p-2 space-y-3">
          <div className="text-body">
            {meta.instructions || "작성된 내용이 없습니다."}
          </div>

          {/* 부적합 사진대지 */}
          {meta.instruction_photoboard && (
            <PhotoBoardReadonly
              photoboardId={meta.instruction_photoboard}
            />
          )}
        </div>
      </section>


      {/* ================= 상세 내용 ================= */}
      <section>
        <table className="w-full border">
          <tbody>
            {[
              { label: "안전 위반 사항", value: meta.scarProblem },
              { label: "즉시 조치 사항", value: meta.scarImmediate },
              { label: "발생 원인", value: meta.scarRootCause },
            ]
              .filter((r) => r.value)
              .map((r, i) => (
                <tr key={i}>
                  <TableCell label={r.label} value={r.value} />
                </tr>
              ))}
          </tbody>
        </table>
      </section>

      {/* ================= 조치 결과 / 확인 의견 ================= */}
      {/* ================= 1차 조치 결과 작성 (이력 없음) ================= */}
      {canWriteAction && actionHistories.length === 0 && (
        <section className="">
          <div className="tbl-label-bg">
            1차 조치 결과 작성
          </div>
          <div className="border-r border-l border-b border-black p-3">
            <textarea
              className="input-base w-full min-h-[220px]"
              placeholder="조치 내용을 입력하세요"
              value={actionText}
              onChange={(e) => setActionText(e.target.value)}
            />
            <div className="mt-3 space-y-2">
              {actionPhotoBoard && (
                <PhotoBoardReadonly photoboardId={actionPhotoBoard} />
              )}

              <button
                className="btn-basic-sm"
                onClick={() => {
                  setPhotoModalContext("action");
                  setPhotoModalOrder(null);
                  setOpenPhotoModal(true);
                }}
              >
                사진대지 선택
              </button>

            </div>

            <div className="mt-2 flex gap-2 justify-end">
              {/* <select
              className="border px-2 py-1"
              value={actionStatus}
              onChange={(e) => setActionStatus(e.target.value)}
            >
              <option value="completed">조치 완료</option>
              <option value="in_progress">진행 중</option>
            </select> */}

              <button
                className="btn-save-sm"
                onClick={handleAddAction}
                disabled={saving}
              >
                {saving ? "저장 중..." : "저장"}
              </button>
            </div>
          </div>


        </section>
      )}

      {mergedHistories.map((h) => {
        const isLast = h.order === actionHistories.length;

        const approvalPhoto =
          meta?.approval_photoboards?.[h.order];

        const showRequestApproval =
          canWriteAction &&
          isLast &&
          doc.status === "none" &&
          h.action.status === "completed";


        const showNextActionEditor =
          canWriteAction &&
          isLast &&
          doc.status === "rejected";


        const showWaitingCM =
          doc.status === "submit" &&
          !h.approval &&
          isLast;

        return (
          <>
            <table className="w-full border text-sm mb-3 ">
              <tbody>
                {/* ===== 조치 결과 ===== */}
                <tr>
                  <td className="tbl-label-bg">
                    <div className="flex items-center justify-between">
                      <span>{h.order}차 조치 결과</span>

                      {showRequestApproval && (
                        <button
                          className="btn-create-sm no-print"
                          onClick={handleSubmitApproval}
                        >
                          결재 요청
                        </button>
                      )}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="tbl-value-bg text-xs">
                    <div className="whitespace-pre-wrap text-xs leading-relaxed">
                      {h.action.content}
                    </div>
                    {h.action.photoboard && (
                      <PhotoBoardReadonly photoboardId={h.action.photoboard} />
                    )}
                    <div className="text-xs text-gray-500 mt-2">
                      {h.action.author_name} / {h.action.date}
                    </div>


                    {/* ===== 결재 요청 버튼 ===== */}


                    {/* ===== CM 확인 대기 ===== */}
                    {showWaitingCM && (
                      <div className="no-print text-xs text-orange-600 mt-2">
                        CM 확인 대기 중
                      </div>
                    )}
                  </td>
                </tr>

                {/* ===== n차 확인 의견 ===== */}
                <tr>
                  <td className="tbl-label-bg">
                    {h.order}차 확인 의견
                  </td>
                </tr>
                <tr>
                  <td className="tbl-value-bg ">
                    <ApprovalAction_CM
                      dns={dns}
                      order={h.order}
                    />
                    {approvalPhoto && (
                      <PhotoBoardReadonly photoboardId={approvalPhoto} />
                    )}
                    {doc.status === "submit" && !h.approval && (
                      <button
                        className="btn-basic-sm no-print"
                        onClick={() => {
                          setPhotoModalContext("approval");
                          setPhotoModalOrder(h.order);
                          setOpenPhotoModal(true);
                        }}
                      >
                        확인 사진대지 선택
                      </button>
                    )}



                  </td>
                </tr>
              </tbody>
            </table>

            {/* ===== 다음 차수 조치 결과 작성 ===== */}
            {showNextActionEditor && (
              <table className="w-full border text-sm mb-4">
                <tbody>
                  <tr>
                    <td className="tbl-label-bg">
                      {nextOrder}차 조치 결과 작성
                    </td>
                  </tr>

                  <tr>
                    <td className="tbl-value-bg">
                      <textarea
                        className="input-base w-full min-h-[220px]"
                        placeholder="조치 내용을 입력하세요"
                        value={actionText}
                        onChange={(e) => setActionText(e.target.value)}
                      />


                      {/* ✅ 선택된 사진대지 미리보기 */}
                      {actionPhotoBoard && (
                        <div className="mt-3">
                          <PhotoBoardReadonly photoboardId={actionPhotoBoard} />
                        </div>
                      )}

                      {/* ✅ 사진대지 선택 버튼 */}
                      <div className="mt-2 flex gap-2">
                        <button
                          className="btn-basic-sm"
                          onClick={() => {
                            setPhotoModalContext("action");
                            setPhotoModalOrder(null); // action은 order 필요 없음
                            setOpenPhotoModal(true);
                          }}
                        >
                          사진대지 선택
                        </button>

                        <button
                          className="btn-save-sm"
                          onClick={handleAddAction}
                          disabled={saving}
                        >
                          {saving ? "저장 중..." : "저장"}
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

          </>

        );
      })}

      <div className="mt-6">
        <SignTableDoc dns={dns} actor={actor} />
      </div>


      <PhotoBoardSelect
        isOpen={openPhotoModal}
        onClose={() => {
          setOpenPhotoModal(false);
          setPhotoModalContext(null);
          setPhotoModalOrder(null);
        }}
        onSelect={async (board) => {
          if (photoModalContext === "action") {
            // ✅ 조치 사진대지
            setActionPhotoBoard(board.id);
          }

          if (photoModalContext === "approval") {
            // ✅ 확인 사진대지
            const latest = await getSafetyDocDetail(dns);
            const latestMeta = latest?.meta || {};

            await saveSafetyDoc({
              dns,
              project: doc.project,
              title: doc.title,
              doc_type: doc.doc_type,
              status: doc.status,
              meta: {
                ...meta,
                approval_photoboards: {
                  ...(meta.approval_photoboards || {}),
                  [photoModalOrder]: board.id,
                },
              },

            });

            setOpenPhotoModal(false);
            setPhotoModalContext(null);
            setPhotoModalOrder(null);
            window.location.reload();

          }

        }}
      />


    </div>
  );
}